import { ref, reactive, computed, toRef, watch } from 'vue'
import { defineStore, storeToRefs } from 'pinia'
import utils from '@/utils/utils'
import { useDdEstate } from '@/stores/due_diligence/ddEstate.store'
import { defaultsOf, entriesHash } from '@/utils/dd/entryHelpers'

export const useDdClient = defineStore('ddClient', () => {

  const model = reactive({})
  const ddEstate = useDdEstate()
  const edc = ddEstate.estateDistributionCalcs

  const heirDistributionHash  = computed(() => entriesHash(defaultsOf(model.heirDistribution)))

  function loadData(responseData) {
    // To update the object's properties while preserving reactivity:
    Object.assign(model, responseData)
    if (!model.identityRisk) model.identityRisk = {}
    // console.log('clientDD.loadData', estateTotals)
  }

  const grandTotals = {
    heirShare: computed(() => {
      // console.log('heirShare', edc.netAvailable, model.shareRate)
      return edc.sharedResidual * (model.shareRate/100 || 0)
    }),
    shareRate: computed(() => model.shareRate),
    debtEntriesSum: computed(() => {
      // Sum every currency entry (default + custom); rate-format defaults are excluded.
      const currencyEntries = utils.filter(model.heirDistribution, (entry) => entry.format=='currency')
      return utils.sumBy(currencyEntries, 'val')
    }),
    prelimDistClient: computed(() => {
      if (!model.id) return 0
      const clientTxns = ddEstate.prelimTxnsInScope.filter(
        t => t.recipientType === 'Member' && t.recipientId === model.id
      )
      return utils.sumBy(clientTxns, 'amount')
    }),
    specificBeqClient: computed(() => {
      if (!model.id) return 0
      return utils.sumBy(
        ddEstate.bequests.filter(b => b.recipientType === 'Member' && b.recipientId === model.id),
        'amount'
      )
    }),
    heirNetInheritance: computed(() => {
      return grandTotals.heirShare.value + grandTotals.specificBeqClient.value - grandTotals.debtEntriesSum.value
    }),
    remainingShareToDist: computed(() =>
      grandTotals.heirNetInheritance.value - (grandTotals.prelimDistClient.value || 0)
    ),
  }

  return {
    // raw data refs
    model,
    // helper methods
    loadData,
    // computed calculations
    // calcs,
    grandTotals,
  }
}, { persist: false }) // Do not persist in localStorage
